import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

import type { GetRememberGoodsListRequest, GetRememberGoodsListResponse } from '../../../app/kymw/kymw74/kymw7400/api-service/get-remember-goods-list.service';
import type { DeleteRememberGoodsListRequest } from '../../../app/kymw/kymw74/kymw7400/api-service/delete-remember-goods-list.service';

// KYMW7400 忘れず注文商品一覧
export const kymw7400Handlers = [
  // 忘れず注文商品一覧取得 /kymw74/getRememberGoodsList
  http.post(PlessService.SERVICE.getRememberGoodsList.url, async ({ request }) => {
    const req = await request.json() as { data: GetRememberGoodsListRequest };
    console.log(PlessService.SERVICE.getRememberGoodsList.url, req);

    const condition = req.data.search.RememberGoodsList.condition;
    const pageNo = Number(condition.Page);

    const toralCount = 1000; // 1000件以上は取得できない機能のため
    const perPage = 100;
    const maxPageNo = Math.ceil(toralCount/perPage);
    const startNum = (pageNo - 1) * perPage + 1;
    const endNum = Math.min(pageNo * perPage, toralCount);

    if (0 < pageNo && pageNo <= maxPageNo) {
      const list = Array.from({ length: (endNum - startNum + 1) }, (_, index) => (
        {
          RememberGoodsStatus: '1',
          RememberGoodsStatusName: '承認待',
          OrderNum: condition.OrderNum ? condition.OrderNum : '000001',
          ClassCode: condition.ClassCode ? condition.ClassCode : `0${condition.Page}`,
          ClassName: `部門名${condition.Page}`,
          BuyerCode: condition.BuyerCode ? condition.BuyerCode : `0010000${condition.Page}`,
          BuyerName: `バイヤー名${condition.Page}`,
          ItemCode: Math.floor(Math.random() * 9000000 + 1000000).toString(), // ランダムな7桁の整数を生成
          Pcode: `P${(startNum + index).toString().padStart(7, '0')}`, // 「P＋ゼロ埋め7桁番号」
          GuideGoodsName: `商品名${(startNum + index)}`,
          GuideStandardName: `規格名${(startNum + index)}`,
          OrderReceptionStartCatalog: condition.OrderReceptionCatalog ? condition.OrderReceptionCatalog : '20240801',
          OrderReceptionEndCatalog: '20240901',
          DeliveryStartCatalog: condition.DeliveryCatalog ? condition.DeliveryCatalog : '20240802',
          DeliveryEndCatalog: '20240902',
          DeliveryCycleDiv: '10',
          DeliveryCycleDivName: '毎週',
          GoodsPrice: '100',
          DiscountUnitPrice: '200',
          DiscountRate: '10',
          RememberGoodsId: `90000${(startNum + index).toString().padStart(3, '0')}`, // オブジェクトのキー値 (5桁＋ゼロ埋め3桁番号)
          OrderChangeOrderNum: '100001',
        }
      ));
      getRememberGoodsListResponse.result.obj.RememberGoodsList = list;
    }

    getRememberGoodsListResponse.result.obj.TotalNum = toralCount.toString();
    getRememberGoodsListResponse.result.obj.StartDispNum = startNum.toString();
    getRememberGoodsListResponse.result.obj.EndDispNum = endNum.toString();

    return HttpResponse.json(getRememberGoodsListResponse);
  }),

  // 忘れず注文商品削除 /kymw74/deleteRememberGoodsList
  http.post(PlessService.SERVICE.deleteRememberGoodsList.url, async ({ request }) => {
    const req = await request.json() as { data: DeleteRememberGoodsListRequest };
    console.log(PlessService.SERVICE.deleteRememberGoodsList.url, req);
    return HttpResponse.json(commonResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
    }),

  // 忘れず注文商品情報確定 /kymw74/confirmRememberGoods
  http.post(PlessService.SERVICE.confirmRememberGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.confirmRememberGoods.url, req);
    return HttpResponse.json(commonResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
    }),
];

const commonResponse = {
  status: 'ok',
  message: '処理完了'
};

const getRememberGoodsListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: '0',
      StartDispNum: '0',
      EndDispNum: '0',
      RememberGoodsList: [],
    } as GetRememberGoodsListResponse,
  }
};
